// extracted by mini-css-extract-plugin
export default {"form":"ClientsCRUD_form_form__E8y2c","inputInner":"ClientsCRUD_form_inputInner__56qU1","formRow":"ClientsCRUD_form_formRow__d5st6","formField":"ClientsCRUD_form_formField__keXOK"};